<template>
  <div>
    <div class="headline">
      <h1>Your doge profile</h1>
    </div>
    <p v-if="profile.name">
      <strong>Name:</strong> {{ profile.name }}
    </p>
  </div>
</template>

<style scoped>
  .headline{
    margin-top: 1em;
    display: flex;
  }
  .headline img {
      height: 80px;
      width: 80px;
      border-radius: 50%;
    }
</style>

<script>
import { mapState } from 'vuex'
import { USER_REQUEST } from '../../store/actions/user'
export default {
  name: 'account',
  computed: mapState({profile: state => state.user.profile}),
  mounted () {
    console.log(USER_REQUEST)
    this.$store.dispatch(USER_REQUEST)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Account/Index.vue